import { useHistory } from "react-router-dom";
import ButtonProps from "../../services/models/buttonProps.model";
import useMobile from "../../utils/helpers/useMobile";
import CustomButton from "../molecular/CustomButton";

function Button({ textInformation, onClick, buttonTheme, loading, ...buttonProps }: ButtonProps): JSX.Element {
  const isMobile = useMobile()
  const history = useHistory()
  const isOrderScreen = history.location.pathname.includes('/access/online-order')
  if (buttonTheme === 'primary')
    return <CustomButton
      textInformation={textInformation}
      loading={loading}
      onClick={onClick}
      {...buttonProps}
      loadingStroke={'#fff'}
      className={`primaryBtn ${loading && 'flex items-center'} ${buttonProps.className} ${buttonProps.disabled && '!border-transparent'}`}
    />

  if (buttonTheme === 'secondary')
    return <CustomButton
      textInformation={textInformation}
      loading={loading}
      onClick={onClick}
      {...buttonProps}
      className={`secondaryBtn ${loading && 'flex items-center'} ${buttonProps.className}`}
    />

  return <CustomButton
    textInformation={textInformation}
    loading={loading}
    onClick={onClick}
    {...buttonProps}
    className={`${isMobile && isOrderScreen ? 'transparentBtnSubmitOrderScreen' : 'transparentBtn' } ${loading && 'flex items-center'} ${buttonProps.className}`}
  />
}

export default Button